import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=1337aeb0&"
import script from "@/scripts/couponVoucherMngt/index.js?vue&type=script&lang=js&"
export * from "@/scripts/couponVoucherMngt/index.js?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=1337aeb0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports